/**
 * Konsolidierte Aufgaben-Seite (P2, UI-Overhaul 2026-07-07).
 *
 * Fasst die früheren Einzel-Routen /kanban, /calendar, /gantt unter einer
 * gemeinsamen Seite mit Unterstrich-Tabs zusammen. Die eigentlichen Inhalte
 * leben unverändert in <KanbanBoard/>, <CalendarView/>, <GanttView/> — hier
 * wird nur die Hülle (PageHeader + Tabs + Query-Param-State) gebaut.
 *
 * Tab-State via ?view=kanban|kalender|zeitachse (Default kanban), damit die
 * alten Routen dorthin redirecten können und Deep-Links stabil bleiben.
 */
import { useSearchParams } from "react-router-dom";
import { PageHeader, Tabs } from "../ui";
import { useT } from "../i18n";
import { KanbanBoard } from "./Kanban";
import { CalendarView } from "./Calendar";
import { GanttView } from "./Gantt";

type ViewId = "kanban" | "kalender" | "zeitachse";

export default function TasksPage() {
  const t = useT();
  const TABS = [
    { id: "kanban", label: t.tasks.reiter.kanban },
    { id: "kalender", label: t.tasks.reiter.kalender },
    { id: "zeitachse", label: t.tasks.reiter.zeitachse },
  ];
  const [params, setParams] = useSearchParams();
  const raw = params.get("view");
  const view: ViewId =
    raw === "kalender" || raw === "zeitachse" ? raw : "kanban";

  const setView = (id: string) => {
    const next = new URLSearchParams(params);
    next.set("view", id);
    setParams(next, { replace: true });
  };

  return (
    <div className="h-full flex flex-col">
      <div className="shrink-0 px-6 pt-6 space-y-4 bg-canvas">
        <PageHeader title={t.tasks.seitenTitel} />
        <Tabs items={TABS} value={view} onChange={setView} />
      </div>
      <div className="flex-1 min-h-0 overflow-auto">
        {view === "kanban" && <KanbanBoard embedded />}
        {view === "kalender" && <CalendarView embedded />}
        {view === "zeitachse" && <GanttView embedded />}
      </div>
    </div>
  );
}
